import React from 'react';
import { CheckCircle, AlertCircle, XCircle } from 'lucide-react';

function Row({ label, ok, warn }) {
  const Icon = ok ? CheckCircle : warn ? AlertCircle : XCircle;
  const color = ok ? 'text-emerald-600' : warn ? 'text-amber-600' : 'text-red-600';
  return (
    <li className="flex items-center gap-2 text-sm">
      <Icon className={`w-4 h-4 ${color}`} />
      <span className="text-gray-700">{label}</span>
    </li>
  );
}

export default function WaBotHealthCard({ health, loading }) {
  const h = health || {};
  if (loading) {
    return <div className="bg-white border rounded-xl p-4 text-sm text-gray-500">Loading health…</div>;
  }
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
      <h2 className="font-semibold text-[#1B375B] mb-3">Bot health</h2>
      <ul className="space-y-2">
        <Row label="Bot enabled (WA_BOT_ENABLED)" ok={h.bot_enabled} />
        <Row label="Interakt API key" ok={h.interakt_configured} />
        <Row label="Webhook secret" ok={h.interakt_webhook_secret_set} warn={!h.interakt_webhook_secret_set} />
        <Row label="Groq NLU" ok={h.groq_configured} />
        <Row label="Gemini formatter" ok={h.gemini_configured} />
        <Row label="Razorpay" ok={h.razorpay_configured} />
        <Row label="Public URL (e-ticket PDF)" ok={h.public_base_set} warn={!h.public_base_set} />
      </ul>
    </div>
  );
}
